<style lang="stylus" scoped>
@import '../cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.map-title {
  padding-bottom: 20px;
  margin-bottom: 16px;
  height: auto;
  border-radius: 5px;
}

.map-data {
  border-radius: 5px;
  margin-bottom: 20px;
}
</style>
<template>
  <div class="home-main">
    <div class="mark" v-if="mark">
      <el-progress type="circle" :percentage="progressNum" class="circle" style="color:#fff;"></el-progress>
    </div>
    <div class="map-search">
      <div class="map-title">
        <el-row>
          <el-col :span="12">
            <div>
              <span class="color2 pointer" @click="goBack(-2)">全国</span>
              <span>></span>
              <span class="color2 pointer" @click="goBack(-1)">{{provinceName}}</span>
              <span>></span>
              <span>{{cityName}}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="t-r">
              <el-date-picker
                :clearable="false"
                v-model="timeSection"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
              <!--  -->
              <el-button v-show="hideExport" style="margin-left:20px;" @click="exportDate">导出</el-button>
              
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <TableDate :allData="tableDatas"/> -->
    <template v-for="(item,index) in allData">
      <TableDate 
        :allData="item" 
        :key="index" 
        :name="item.siteName||item.areaName" 
        :code="item.siteCode"/>
    </template>
  </div>
</template>
<script>
import http from '@/api/consump.js' //请求汇总
import TableDate from '../components/initDate' //表格数据
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
export default {
  data() {
    return {
      hideExport:hideExport,
      mark: false, //遮罩层开关
      timeSection: [
        new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 0 * 24 * 3600 * 1000) * 1
      ],
      progressNum: 0, //下载进度条进度
      provinceName: null,
      cityName: null,
      cityCode: null,
      tableDatas: [],
      allData: []
    }
  },
  created() {
    this.provinceName = decodeURIComponent(this.$route.query.provinceName)
    this.cityName = decodeURIComponent(this.$route.query.cityName)
    this.cityCode = decodeURIComponent(this.$route.query.cityCode)
    this.timeSection = JSON.parse(this.$route.query.times)
  },
  mounted() {
    this.init()
  },
  watch: {
    timeSection: function() {
      //this.init()
    }
  },
  methods: {
    init() {
      let that = this
      http.allCard({
          timeSection: that.timeSection,
          cityCode: this.cityCode,
          type:3
        })
        .then(e => {
          that.allData = [...e.data]
          // that.tableDatas = e.data.cardCustomerInfo
          //that.allData = [...e.data.dispersed]
        })
      // that.initSity()
    },
    initSity() {
      let that = this
      http
        .siteCard({ timeSection: that.timeSection, cityCode: this.cityCode })
        .then(e => {
          //that.tableDatas = [...e.data.total]
          that.allData = [...e.data]
        })
    },
    exportDate() {
      //导出
      let that = this
      that.mark = true
      let reqId = Cookies.get('user')
      let times
      times = setInterval(function() {
        http.progress({ reqId }).then(e => {
          that.progressNum = e.data.percent
          if (e.data.percent >= 100) {
            that.mark = false
            that.progressNum = 0
            clearInterval(times)
          }
        })
      }, 100)
      reqId += new Date() * 1
      window.location.assign(
        http.cardSity({
          start: that.timeSection[0],
          end: that.timeSection[1],
          cityCode: that.cityCode,
          reqId
        })
      )
    },
    goBack(num) {
      this.$router.go(num)
    }
  },
  components: {
    TableDate
  }
}
</script>
